import {css} from "emotion";

export const styles = () => {
    return css`
      display: inline-block;
      font-size: .6em;
      padding: 1px;
      border: 1px solid #c45fc0;
      border-radius: 5px;
      margin-left: 2px;
      width: 23px;
      text-align: center;
    `
}